import { agtiTokenIcon } from 'assets/images';
import { Chains, IChainType, IConnectWallet, IContracts } from 'types';
import { AbiItem } from 'web3-utils';

import { erc20Abi, stakingAbi } from './abi';

export const isMainnet = true;

export const chains: {
  [key in Chains]: {
    [key: string]: {
      name: string;
      nativeCurrency: {
        name: string;
        symbol: string;
        decimals: number;
      };
      rpc: string;
      blockExplorerUrl: string;
      chainId: number;
      provider: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
      };

      img?: string;
    };
  };
} = {
  [Chains.bsc]: {
    mainnet: {
      name: 'Binance-Smart-Chain',
      chainId: 56,
      nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18,
      },
      rpc: 'https://bsc-dataseed.binance.org/',
      blockExplorerUrl: 'https://bscscan.com',
      provider: {
        MetaMask: { name: 'MetaMask' },
        WalletConnect: {
          name: 'WalletConnect',
          useProvider: 'rpc',
          provider: {
            rpc: {
              rpc: {
                56: 'https://bsc-dataseed.binance.org/',
              },
              chainId: 56,
            },
          },
        },
      },
    },
    testnet: {
      name: 'Binance-Smart-Chain-Testnet',
      chainId: 97,
      nativeCurrency: {
        name: 'TBNB',
        symbol: 'TBNB',
        decimals: 18,
      },
      rpc: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
      blockExplorerUrl: 'https://testnet.bscscan.com',
      provider: {
        MetaMask: { name: 'MetaMask' },
        WalletConnect: {
          name: 'WalletConnect',
          useProvider: 'rpc',
          provider: {
            rpc: {
              rpc: {
                97: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
              },
              chainId: 97,
            },
          },
        },
      },
    },
  },
};

export const connectWallet = (newChainName: Chains, type: IChainType): IConnectWallet => {
  const chain = chains[newChainName][type];
  return {
    network: {
      chainName: chain.name,
      chainID: chain.chainId,
      nativeCurrency: chain.nativeCurrency,
      rpc: chain.rpc,
      blockExplorerUrl: chain.blockExplorerUrl,
    },
    provider: chain.provider,
    settings: { providerType: true },
  };
};

export enum ContractsNames {
  agti,
  staking,
}

export type IContractsNames = keyof typeof ContractsNames;

export const contractsConfig: IContracts = {
  names: Object.keys(ContractsNames),
  decimals: 18,
  contracts: {
    [ContractsNames.agti]: {
      testnet: {
        address: {
          [Chains.bsc]: '0x42c0D67499C722FaE3cE695E90FcD0aecFF52940',
        },
        abi: erc20Abi as AbiItem[],
        symbol: 'AGTI',
        decimals: 0,
        img: agtiTokenIcon,
      },
      mainnet: {
        address: {
          [Chains.bsc]: '0xE67feefC1c3C9725397a303B6Fcb5c099411e7b4',
        },
        abi: erc20Abi as AbiItem[],
        symbol: 'AGTI',
        decimals: 0,
        img: agtiTokenIcon,
      },
    },

    [ContractsNames.staking]: {
      testnet: {
        address: {
          [Chains.bsc]: '0x367107D0F3Cc76E8EaC27ad9c6da66eb0E94Fe25',
        },
        abi: stakingAbi as AbiItem[],
      },
      mainnet: {
        address: {
          [Chains.bsc]: '0x820c136321e871B1044abD68a6A440554421237D',
        },
        abi: stakingAbi as AbiItem[],
      },
    },
  },
};
